export const AUTH_STORAGE_KEY = 'mb_auth_v2';

export const MAILCHIMP = {
	server: 'us20',
	masterListId: '293708',
};
